import { render } from "./StaffList.vue?vue&type=template&id=b2168a72&scoped=true&ts=true"
import script from "./StaffList.vue?vue&type=script&lang=ts"
export * from "./StaffList.vue?vue&type=script&lang=ts"

import "./StaffList.vue?vue&type=style&index=0&id=b2168a72&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2168a72"]])

export default __exports__